/* Olyra — pages produit Q4 2026. Script commun aux sections olyra-<produit>-*. Aucune dépendance. */
(() => {
  const money = (cents, fmt) => {
    const f = fmt || '${{amount}}';
    if (!/\{\{/.test(f)) return f;
    const n = (cents || 0) / 100;
    const fix = (d, th, dec) => {
      const p = n.toFixed(d).split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return p.join(dec);
    };
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => ({
      amount: fix(2, ',', '.'),
      amount_no_decimals: fix(0, ',', '.'),
      amount_with_comma_separator: fix(2, '.', ','),
      amount_no_decimals_with_comma_separator: fix(0, '.', ',')
    }[k] || fix(2, ',', '.')));
  };

  // Prix au format réglé dans la section (ex. "[amount] €", "," et ".") ; sinon format Shopify.
  const priceFmt = (data) => (cents, withCur) => {
    if (data.priceFormat) {
      const n = Math.round(cents || 0);
      const e = String(Math.floor(n / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, data.thousandsSep || '');
      const c = String(n % 100).padStart(2, '0');
      return data.priceFormat.replace('[amount]', e + (data.decimalSep || ',') + c);
    }
    return money(cents, withCur ? (data.moneyCurrencyFormat || data.moneyFormat) : data.moneyFormat);
  };

  function initMain(root) {
    if (!root || root.dataset.oq4Ready) return;
    root.dataset.oq4Ready = '1';
    const dataEl = root.querySelector('[data-oq4-product]');
    if (!dataEl) return;
    const data = JSON.parse(dataEl.textContent);
    const form = root.querySelector('[data-oq4-form]');
    const idInput = root.querySelector('[data-oq4-id]');
    const btn = root.querySelector('[data-oq4-add]');
    const msg = root.querySelector('[data-oq4-msg]');
    const packIdx = data.packIndex;
    const fmt = priceFmt(data);
    const stockEl = root.querySelector('[data-oq4-stock]');

    const current = () => {
      const sel = [];
      data.options.forEach((name, i) => {
        const checked = root.querySelector(`[data-oq4-opt="${i}"]:checked`);
        sel[i] = checked ? checked.value : null;
      });
      return sel;
    };
    const find = sel => data.variants.find(v => v.options.every((o, i) => sel[i] === null || sel[i] === o));

    function render() {
      const sel = current();
      const v = find(sel);
      // cartes de lots
      if (packIdx >= 0) {
        let base = 0;
        root.querySelectorAll('[data-oq4-lot]').forEach(card => {
          const s = sel.slice(); s[packIdx] = card.dataset.value;
          const lv = find(s);
          const units = parseInt(card.dataset.units || '1', 10);
          const now = card.querySelector('[data-oq4-lot-now]');
          const was = card.querySelector('[data-oq4-lot-was]');
          const each = card.querySelector('[data-oq4-lot-each]');
          const save = card.querySelector('[data-oq4-lot-save]');
          card.classList.toggle('is-unavailable', !lv || !lv.available);
          card.hidden = !lv;
          if (!lv) return;
          if (units === 1) base = lv.price;
          if (now) now.textContent = fmt(lv.price, true);
          if (was) was.textContent = lv.compare_at_price > lv.price ? fmt(lv.compare_at_price) : '';
          if (each) each.textContent = units > 1 ? (data.eachLabel || '').replace('[price]', fmt(Math.round(lv.price / units))) : '';
          if (save) save.textContent = units > 1 && base * units > lv.price ? (data.saveLabel || '').replace('[amount]', fmt(base * units - lv.price)) : '';
        });
      }
      if (packIdx >= 0) {
        const vis = [...root.querySelectorAll('[data-oq4-lot]:not([hidden]) [data-oq4-opt]')];
        if (vis.length && !vis.some(i => i.checked)) { vis[0].checked = true; return render(); }
      }
      root.querySelectorAll('[data-oq4-optsel]').forEach(el => { const i = el.dataset.oq4Optsel; el.textContent = sel[i] || ''; });
      if (!v) { if (btn) { btn.disabled = true; btn.querySelector('[data-oq4-label]').textContent = data.unavailableLabel; } return; }
      idInput.value = v.id;
      root.querySelectorAll('[data-oq4-price-now]').forEach(el => { el.textContent = fmt(v.price, true); });
      root.querySelectorAll('[data-oq4-price-was]').forEach(el => { el.textContent = v.compare_at_price > v.price ? fmt(v.compare_at_price) : ''; el.hidden = !(v.compare_at_price > v.price); });
      // stock réel : affiché seulement si la variante est suivie en stock et sous le seuil
      if (stockEl) {
        const th = parseInt(stockEl.dataset.threshold || '0', 10);
        const q = v.inv;
        const show = typeof q === 'number' && q > 0 && q <= th;
        stockEl.hidden = !show;
        if (show) { const t = stockEl.querySelector('[data-oq4-stock-text]'); if (t) t.textContent = (stockEl.dataset.text || '').replace('[qty]', q); }
      }
      if (btn) {
        btn.disabled = !v.available;
        btn.querySelector('[data-oq4-label]').textContent = v.available ? data.addLabel : data.soldOutLabel;
      }
      document.querySelectorAll('[data-oq4-sticky-price]').forEach(el => { el.textContent = fmt(v.price, true); });
      if (data.updateUrl && window.history && history.replaceState && !window.Shopify?.designMode) {
        const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u);
      }
    }
    const showVariantImage = () => {
      const v = find(current());
      const tr = root.querySelector('[data-oq4-track]');
      if (!v || !v.img || !tr) return;
      const slides = [...tr.children];
      const i = slides.findIndex(s => [...s.querySelectorAll('img')].some(im => (im.currentSrc || im.src || '').includes(v.img)));
      if (i < 0) return;
      const th = root.querySelectorAll('[data-oq4-thumb]')[i];
      if (th) th.click();
      else tr.scrollTo({ left: slides[i].offsetLeft - tr.offsetLeft, behavior: 'smooth' });
    };
    root.addEventListener('change', e => { if (e.target.matches('[data-oq4-opt]')) { render(); showVariantImage(); } });
    render();

    if (form) form.addEventListener('submit', async e => {
      if (!window.fetch) return;
      e.preventDefault();
      if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
      if (msg) msg.textContent = '';
      const items = [{ id: Number(idInput.value), quantity: 1 }];
      root.querySelectorAll('[data-oq4-addon]:checked').forEach(a => { if (a.value) items.push({ id: Number(a.value), quantity: 1 }); });
      try {
        const r = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
        if (!r.ok) { const j = await r.json().catch(() => ({})); throw new Error(data.errorLabel || j.description || j.message); }
        if (window.oq4Cart) window.oq4Cart.open(); else location.href = data.cartUrl;
        if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
      } catch (err) {
        if (msg) msg.textContent = err.message || data.errorLabel;
        if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
      }
    });

    // galerie
    const track = root.querySelector('[data-oq4-track]');
    const thumbs = [...root.querySelectorAll('[data-oq4-thumb]')];
    if (track && thumbs.length) {
      thumbs.forEach((t, i) => t.addEventListener('click', () => {
        const slide = track.children[i];
        if (slide) track.scrollTo({ left: slide.offsetLeft - track.offsetLeft - parseFloat(getComputedStyle(track).paddingLeft || 0), behavior: 'smooth' });
      }));
      let raf;
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          const i = Math.round(track.scrollLeft / (track.clientWidth || 1));
          thumbs.forEach((t, k) => t.setAttribute('aria-current', k === i ? 'true' : 'false'));
        });
      }, { passive: true });
    }
  }

  function initSticky(root) {
    if (!root || root.dataset.oq4Ready) return;
    root.dataset.oq4Ready = '1';
    const target = document.querySelector('[data-oq4-add]') || document.getElementById('oq4-buy');
    const past = root.dataset.oq4StickyMode === 'past';
    if (!target || !('IntersectionObserver' in window)) { root.classList.add('is-on'); return; }
    const io = new IntersectionObserver(([en]) => {
      // visible tant que le bouton d'achat n'est pas à l'écran (avant comme après) : un CTA toujours atteignable
      // mode « past » : seulement quand le bouton principal est sorti de l'écran par le haut
      root.classList.toggle('is-on', !en.isIntersecting && (!past || en.boundingClientRect.top < 0));
    });
    io.observe(target);
    root._oq4io = io;
  }

  function initStrip(root) {
    root.querySelectorAll('[data-oq4-strip]').forEach(strip => {
      const nav = strip.parentElement.querySelector('[data-oq4-strip-nav]');
      if (!nav || nav.dataset.ready) return;
      nav.dataset.ready = '1';
      nav.querySelectorAll('button').forEach(b => b.addEventListener('click', () => {
        strip.scrollBy({ left: (b.dataset.dir === 'prev' ? -1 : 1) * strip.clientWidth * 0.8, behavior: 'smooth' });
      }));
    });
  }

  function initVideos(root) {
    const vids = root.querySelectorAll('video[data-oq4-loop]');
    if (!vids.length) return;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver(ens => ens.forEach(en => {
      const v = en.target;
      if (en.isIntersecting) { v.play().catch(() => {}); } else { v.pause(); }
    }), { rootMargin: '200px' });
    vids.forEach(v => io.observe(v));
  }

  // Compte à rebours vers une date fixe (réglée dans l'éditeur) : rien n'est stocké, il ne se relance pas
  // au rechargement ; après la date, il est retiré (ou remplacé par le texte « après la date »).
  const cds = new Set();
  let cdTimer = null;
  function tickCountdowns() {
    const now = Date.now();
    cds.forEach(el => {
      if (!el.isConnected) { cds.delete(el); return; }
      const end = Date.parse(el.dataset.end);
      let left = Math.floor((end - now) / 1000);
      if (!(left > 0)) {
        // échéance passée : on retire cette case, la suivante du groupe prend le relais, sinon le texte « après »
        cds.delete(el);
        el.hidden = true;
        const g = el.closest('[data-oq4-cd-group]');
        if (g) {
          const next = [...g.querySelectorAll('[data-oq4-cd]')].find(x => Date.parse(x.dataset.end) > now);
          if (next) next.hidden = false;
          else { const after = g.querySelector('[data-oq4-cd-after]'); if (after) after.hidden = false; else g.hidden = true; }
        }
        return;
      }
      const d = Math.floor(left / 86400); left -= d * 86400;
      const h = Math.floor(left / 3600); left -= h * 3600;
      const m = Math.floor(left / 60); const s = left - m * 60;
      const set = (k, v) => el.querySelectorAll(`[data-oq4-cd-${k}]`).forEach(n => { n.textContent = n.hasAttribute('data-raw') ? String(v) : String(v).padStart(2, '0'); });
      set('d', d); set('h', h); set('m', m); set('s', s);
    });
    if (!cds.size && cdTimer) { clearInterval(cdTimer); cdTimer = null; }
  }
  function initCountdown(scope) {
    scope.querySelectorAll('[data-oq4-cd]').forEach(el => { if (!Number.isNaN(Date.parse(el.dataset.end))) cds.add(el); });
    tickCountdowns();
    if (cds.size && !cdTimer) cdTimer = setInterval(tickCountdowns, 1000);
  }

  // « Pide hoy y recíbelo entre el X y el Y » : dates calculées dans le navigateur depuis les réglages
  function addDays(start, n, business) {
    const d = new Date(start.getTime());
    let k = 0;
    while (k < n) { d.setDate(d.getDate() + 1); if (!business || (d.getDay() !== 0 && d.getDay() !== 6)) k++; }
    return d;
  }
  function initDelivery(scope) {
    scope.querySelectorAll('[data-oq4-ship]').forEach(el => {
      const now = new Date();
      const start = new Date(now.getTime());
      const cut = parseInt(el.dataset.cutoff || '24', 10);
      const business = el.dataset.business === '1';
      if (now.getHours() >= cut) start.setDate(start.getDate() + 1);
      if (business) while (start.getDay() === 0 || start.getDay() === 6) start.setDate(start.getDate() + 1);
      const min = parseInt(el.dataset.min || '0', 10), max = parseInt(el.dataset.max || '0', 10);
      const opts = { day: 'numeric', month: 'long' };
      if (el.dataset.weekday === '1') opts.weekday = 'long';
      let f;
      try { f = new Intl.DateTimeFormat(el.dataset.locale || document.documentElement.lang || 'es-ES', opts); } catch { f = new Intl.DateTimeFormat('es-ES', opts); }
      const a = el.querySelector('[data-oq4-ship-start]'), b = el.querySelector('[data-oq4-ship-end]');
      const nb = d => f.format(d).replace(/ /g, '\u00a0');   // « 26. Oktober » ne se coupe plus en fin de ligne
      if (a) a.textContent = nb(addDays(start, min, business));
      if (b) b.textContent = nb(addDays(start, max, business));
    });
  }

  function initHeader(scope) {
    scope.querySelectorAll('[data-oq4-hh]').forEach(h => {
      if (h.dataset.oq4Ready) return; h.dataset.oq4Ready = '1';
      const drawer = h.querySelector('[data-oq4-hh-drawer]'); const open = h.querySelector('[data-oq4-hh-open]');
      if (!drawer || !open) return;
      const close = () => { drawer.hidden = true; open.setAttribute('aria-expanded', 'false'); document.body.style.overflow = ''; open.focus(); };
      open.addEventListener('click', () => { drawer.hidden = false; open.setAttribute('aria-expanded', 'true'); document.body.style.overflow = 'hidden'; const f = drawer.querySelector('a, button'); if (f) f.focus(); });
      drawer.querySelectorAll('[data-oq4-hh-close]').forEach(b => b.addEventListener('click', close));
      drawer.addEventListener('keydown', e => { if (e.key === 'Escape') close(); });
      drawer.querySelectorAll('a[href^="#"]').forEach(a => a.addEventListener('click', () => { drawer.hidden = true; open.setAttribute('aria-expanded', 'false'); document.body.style.overflow = ''; }));
    });
  }

  function initAll(scope) {
    initCountdown(scope);
    initDelivery(scope);
    initHeader(scope);
    scope.querySelectorAll('[data-oq4-main]').forEach(initMain);
    scope.querySelectorAll('[data-oq4-sticky]').forEach(initSticky);
    initStrip(scope);
    initVideos(scope);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(document));
  else initAll(document);
  document.addEventListener('shopify:section:load', e => initAll(e.target));
  document.addEventListener('shopify:section:unload', e => {
    e.target.querySelectorAll('[data-oq4-sticky]').forEach(s => { if (s._oq4io) s._oq4io.disconnect(); });
    e.target.querySelectorAll('[data-oq4-cd]').forEach(el => cds.delete(el));
    document.body.style.overflow = '';
  });
  document.addEventListener('shopify:block:select', e => {
    const slide = e.target.closest('[data-oq4-slide]');
    if (slide) slide.scrollIntoView({ block: 'nearest', inline: 'center' });
  });
})();

/* Tiroir panier Olyra Q4 : s'ouvre après « ajouter au panier » et sur l'icône panier ; le bouton mène direct au paiement. */
(() => {
  const L = {
    es: { title: 'Tu carrito', empty: 'Tu carrito está vacío', sub: 'Subtotal', ship: 'Envío gratis', go: 'Finalizar compra', cont: 'Seguir comprando', rm: 'Eliminar', close: 'Cerrar', note: 'Impuestos incluidos. Pago 100 % seguro.' },
    pt: { title: 'O teu carrinho', empty: 'O teu carrinho está vazio', sub: 'Subtotal', ship: 'Envio grátis', go: 'Finalizar compra', cont: 'Continuar a comprar', rm: 'Remover', close: 'Fechar', note: 'Impostos incluídos. Pagamento 100 % seguro.' },
    de: { title: 'Dein Warenkorb', empty: 'Dein Warenkorb ist leer', sub: 'Zwischensumme', ship: 'Kostenloser Versand', go: 'Zur Kasse', cont: 'Weiter einkaufen', rm: 'Entfernen', close: 'Schließen', note: 'Inkl. MwSt. 100 % sichere Zahlung.' },
    it: { title: 'Il tuo carrello', empty: 'Il tuo carrello è vuoto', sub: 'Subtotale', ship: 'Spedizione gratuita', go: 'Procedi al pagamento', cont: 'Continua lo shopping', rm: 'Rimuovi', close: 'Chiudi', note: 'Tasse incluse. Pagamento 100% sicuro.' },
    en: { title: 'Your cart', empty: 'Your cart is empty', sub: 'Subtotal', ship: 'Free shipping', go: 'Checkout', cont: 'Continue shopping', rm: 'Remove', close: 'Close', note: 'Taxes included. 100% secure checkout.' }
  };
  const lang = (document.documentElement.lang || 'es').slice(0, 2).toLowerCase();
  const t = L[lang] || L.es;
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const loc = { es: 'es-ES', pt: 'pt-PT', de: 'de-DE', it: 'it-IT', en: 'en-CA' }[lang] || 'es-ES';
  let cur = 'EUR';
  const fmt = c => { try { return new Intl.NumberFormat(loc, { style: 'currency', currency: cur }).format((c || 0) / 100); } catch { return ((c || 0) / 100).toFixed(2) + ' ' + cur; } };
  const esc = s => String(s == null ? '' : s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

  const css = `
  .oq4c{position:fixed;inset:0;z-index:2147483000;display:flex;justify-content:flex-end;visibility:hidden;pointer-events:none}
  .oq4c.is-open{visibility:visible;pointer-events:auto}
  .oq4c__bg{position:absolute;inset:0;background:rgba(0,0,0,.45);opacity:0;transition:opacity .25s}
  .oq4c.is-open .oq4c__bg{opacity:1}
  .oq4c__p{position:relative;width:min(420px,100%);height:100%;background:#fff;color:#111;display:flex;flex-direction:column;transform:translateX(100%);transition:transform .3s ease;font:15px/1.4 inherit;box-shadow:-8px 0 30px rgba(0,0,0,.15)}
  .oq4c.is-open .oq4c__p{transform:none}
  .oq4c__h{display:flex;align-items:center;justify-content:space-between;padding:18px 20px;border-bottom:1px solid #eee}
  .oq4c__h b{font-size:18px}
  .oq4c__x{background:none;border:0;font-size:28px;line-height:1;cursor:pointer;color:#111;padding:4px 8px}
  .oq4c__ship{margin:0;padding:10px 20px;background:#f3f7f2;color:#1f6b33;font-weight:600;font-size:14px;text-align:center}
  .oq4c__list{flex:1;overflow:auto;padding:8px 20px}
  .oq4c__it{display:grid;grid-template-columns:76px 1fr auto;gap:12px;padding:14px 0;border-bottom:1px solid #f0f0f0;align-items:start}
  .oq4c__it img{width:76px;height:76px;object-fit:cover;border-radius:10px;background:#f6f6f6}
  .oq4c__n{font-weight:600;font-size:14px;margin:0 0 2px}
  .oq4c__v{color:#666;font-size:13px;margin:0 0 8px}
  .oq4c__q{display:inline-flex;align-items:center;border:1px solid #ddd;border-radius:8px}
  .oq4c__q button{background:none;border:0;width:30px;height:30px;font-size:16px;cursor:pointer;color:#111}
  .oq4c__q span{min-width:22px;text-align:center;font-size:14px}
  .oq4c__rm{display:block;background:none;border:0;padding:0;margin-top:6px;color:#666;font-size:12px;text-decoration:underline;cursor:pointer}
  .oq4c__pr{font-weight:700;font-size:14px;text-align:right;white-space:nowrap}
  .oq4c__pr s{display:block;color:#999;font-weight:400;font-size:12px}
  .oq4c__e{padding:40px 0;text-align:center;color:#666}
  .oq4c__f{padding:16px 20px calc(16px + env(safe-area-inset-bottom,0px));border-top:1px solid #eee}
  .oq4c__t{display:flex;justify-content:space-between;font-weight:700;font-size:16px;margin-bottom:4px}
  .oq4c__note{color:#666;font-size:12px;margin:0 0 12px}
  .oq4c__go{display:block;width:100%;text-align:center;background:#111;color:#fff;border:0;border-radius:14px;padding:16px;font-weight:700;font-size:16px;cursor:pointer;text-decoration:none}
  .oq4c__go[aria-disabled=true]{opacity:.5;pointer-events:none}
  .oq4c__c{display:block;width:100%;background:none;border:0;margin-top:10px;color:#111;text-decoration:underline;cursor:pointer;font-size:14px}
  .oq4c.is-busy .oq4c__list{opacity:.5}`;

  let el, list, total, go, last;
  function build() {
    if (el) return;
    const st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);
    el = document.createElement('div');
    el.className = 'oq4c'; el.setAttribute('aria-hidden', 'true');
    el.innerHTML = `<div class="oq4c__bg" data-x></div><aside class="oq4c__p" role="dialog" aria-modal="true" aria-label="${esc(t.title)}">
      <div class="oq4c__h"><b>${esc(t.title)}</b><button type="button" class="oq4c__x" data-x aria-label="${esc(t.close)}">&times;</button></div>
      <p class="oq4c__ship">🚚 ${esc(t.ship)}</p>
      <div class="oq4c__list" data-l></div>
      <div class="oq4c__f"><div class="oq4c__t"><span>${esc(t.sub)}</span><span data-t></span></div><p class="oq4c__note">${esc(t.note)}</p>
      <a class="oq4c__go" data-go href="${root}checkout">${esc(t.go)}</a><button type="button" class="oq4c__c" data-x>${esc(t.cont)}</button></div></aside>`;
    document.body.appendChild(el);
    list = el.querySelector('[data-l]'); total = el.querySelector('[data-t]'); go = el.querySelector('[data-go]');
    el.addEventListener('click', e => {
      if (e.target.closest('[data-x]')) return close();
      const b = e.target.closest('[data-q]');
      if (b) change(b.dataset.k, Math.max(0, parseInt(b.dataset.q, 10)));
    });
    el.addEventListener('keydown', e => { if (e.key === 'Escape') close(); });
  }
  function render(cart) {
    cur = cart.currency || cur;
    if (!cart.items.length) { list.innerHTML = `<p class="oq4c__e">${esc(t.empty)}</p>`; go.setAttribute('aria-disabled', 'true'); }
    else {
      go.removeAttribute('aria-disabled');
      list.innerHTML = cart.items.map(i => {
        const img = i.image ? i.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : '';
        const v = i.variant_title && !/default/i.test(i.variant_title) ? i.variant_title : '';
        const was = i.original_line_price > i.final_line_price ? `<s>${fmt(i.original_line_price)}</s>` : '';
        return `<div class="oq4c__it">${img ? `<img src="${esc(img)}" alt="" width="76" height="76" loading="lazy">` : '<span></span>'}
          <div><p class="oq4c__n">${esc(i.product_title)}</p>${v ? `<p class="oq4c__v">${esc(v)}</p>` : ''}
          <div class="oq4c__q"><button type="button" data-k="${esc(i.key)}" data-q="${i.quantity - 1}" aria-label="-">−</button><span>${i.quantity}</span><button type="button" data-k="${esc(i.key)}" data-q="${i.quantity + 1}" aria-label="+">+</button></div>
          <button type="button" class="oq4c__rm" data-k="${esc(i.key)}" data-q="0">${esc(t.rm)}</button></div>
          <div class="oq4c__pr">${was}${fmt(i.final_line_price)}</div></div>`;
      }).join('');
    }
    total.textContent = fmt(cart.total_price);
    document.querySelectorAll('.oq4-header__count').forEach(c => { c.textContent = cart.item_count; c.hidden = !cart.item_count; });
  }
  async function load() { const r = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }); return r.json(); }
  async function change(key, q) {
    el.classList.add('is-busy');
    try { const r = await fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: q }) }); render(await r.json()); }
    finally { el.classList.remove('is-busy'); }
  }
  async function open() {
    build();
    last = document.activeElement;
    el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden';
    el.classList.add('is-busy');
    try { render(await load()); } catch (e) { location.href = root + 'cart'; return; } finally { el.classList.remove('is-busy'); }
    const x = el.querySelector('.oq4c__go'); if (x) x.focus();
  }
  function close() {
    if (!el) return;
    el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true'); document.body.style.overflow = '';
    if (last && last.focus) last.focus();
  }
  window.oq4Cart = { open, close };
  document.addEventListener('click', e => {
    const a = e.target.closest('a.oq4-header__cart, a[href$="/cart"][data-oq4-cart]');
    if (!a || e.metaKey || e.ctrlKey) return;
    e.preventDefault(); open();
  });
})();
